// Single source of truth for company identity shown on Contact, About and the footer.
export const COMPANY = {
  name: "Arcade Ops",
  parent: "Damani Holdings",
  founder: { name: "Aziz Damani", title: "Founder" },
  address: {
    street: "5675 Jimmy Carter Blvd, Suite 725",
    city: "Norcross",
    state: "GA",
    zip: "30071",
  },
};

export const ADDRESS_LINE = `${COMPANY.address.street}, ${COMPANY.address.city}, ${COMPANY.address.state} ${COMPANY.address.zip}`;
export const MAPS_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(ADDRESS_LINE)}`;
